import React, { useState } from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function CmsView({ cms }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                    <Tooltip id="tooltip-top">
                        View
                    </Tooltip>
                }
            >
                <img src="/images/png/view.png" onClick={handleShow} className="pointer" width={35} alt="action" />
            </OverlayTrigger>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View CMS</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">
                        <div className="col-12">
                            <Form.Label className='mb-0'>Title</Form.Label>
                            <p>{cms.title}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Content</Form.Label>
                            <p dangerouslySetInnerHTML={{ __html: cms.content ? cms.content : "" }} />
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Created Date</Form.Label>
                            <p>{cms.createdAt ? new Date(cms.createdAt).toISOString().split('T')[0] : "-"}</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CmsView